<template>
  <div
    :class="[
      !isInsideTable && '@container',
      'overflow-hidden',
      !props.hideBorder && 'rounded-lg shadow-sm ',
      classes,
    ]"
  >
    <slot />
  </div>
</template>

<script setup>
import { useTableContext } from '@/Common/Lists/Tables/useTableContext'
import { computed } from 'vue'

const props = defineProps({
  hideBorder: Boolean,
  background: {
    default: 'white',
  },
})

const colorClasses = computed(() => {
  return {
    white:
      'bg-white dark:bg-gray-900 ring-1 ring-gray-900/5 dark:ring-white/10',
    gray: 'bg-gray-50 dark:bg-gray-800 ring-1 ring-gray-900/5 dark:ring-white/5',
    yellow:
      'bg-yellow-50 dark:bg-yellow-800 ring-1 ring-yellow-900/5 dark:ring-white/5',
    null: '',
  }[props.background]
})
const classes = computed(() => [colorClasses.value].join(' '))

const { isInsideTable } = useTableContext()
</script>
